module.exports = __webpack_public_path__ + "img/undo.5f123412.svg";